import { actionGenerator } from '../../types/redux/actionGenerator';
import { EAgreementActionTypes } from './types';
export var acceptLicence = actionGenerator(EAgreementActionTypes.LicenceAccepted);